'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    appItemStaticClassNames: function() {
        return appItemStaticClassNames;
    },
    useAppItemStaticStyles_unstable: function() {
        return useAppItemStaticStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useAppItemStylesstyles = require("../AppItem/useAppItemStyles.styles");
const _sharedNavStylesstyles = require("../sharedNavStyles.styles");
const appItemStaticClassNames = {
    root: 'fui-AppItemStatic',
    icon: 'fui-AppItemStatic__icon'
};
const useAppItemStaticStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        Bceei9c: "f158kwzp",
        Jwef8y: "fmaajru",
        ecr2s2: "f11z5bqc"
    }
}, {
    d: [
        ".f158kwzp{cursor:default;}"
    ],
    h: [
        ".fmaajru:hover{background-color:unset;}"
    ],
    a: [
        ".f11z5bqc:active{background-color:unset;}"
    ]
});
const useAppItemStaticStyles_unstable = (state)=>{
    'use no memo';
    const rootDefaultClassName = (0, _sharedNavStylesstyles.useRootDefaultClassName)();
    const iconStyles = (0, _sharedNavStylesstyles.useIconStyles)();
    const appItemSpecificStyles = (0, _useAppItemStylesstyles.useAppItemStyles)();
    const appItemStaticStyles = useAppItemStaticStyles();
    const { density, icon } = state;
    state.root.className = (0, _react.mergeClasses)(rootDefaultClassName, appItemStaticClassNames.root, appItemSpecificStyles.root, appItemStaticStyles.root, density === 'small' && appItemSpecificStyles.small, !icon && appItemSpecificStyles.absentIconRootAdjustment, state.root.className);
    if (state.icon) {
        state.icon.className = (0, _react.mergeClasses)(appItemStaticClassNames.icon, iconStyles.base, state.icon.className);
    }
    return state;
};
